import React from 'react'
import styled from 'styled-components'

import { colors } from '@/config/global-parameters'

import ProgressBarBase from './ProgressBar'

interface IParticipationItem {
  className?: string
  padron: number
  participation: number
  shortLabel: string
}

const ParticipationItem = ({
  className,
  padron,
  participation,
  shortLabel,
}: IParticipationItem) => {
  const options = [
    {
      color: colors.colorBlack,
      count: participation,
      key: shortLabel,
    },
    {
      color: colors.colorWhite,
      count: padron - participation,
      key: `no_${shortLabel}`,
    },
  ]

  return (
    <Wrapper className={className}>
      <ElectionChart>
        <ProgressBar
          bordered
          height="19px"
          labeled
          options={options}
          separatorBlend
          textBlend
          total={padron}
        />
      </ElectionChart>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: contents;
  > * {
    padding: 10px 0;
  }
`

const ProgressBar = styled(ProgressBarBase)`
  & :after {
    margin: 1px 0;
  }
  min-width: 70px;
  width: 100%;
`

const ElectionChart = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export default ParticipationItem
